// This lists options that apply to packages. The option names/keys are used to get translations from .properties files.
// Example: "skipass" in this config takes "planningSummary_options_skipass" content from translation

export default {
    HS: [],
    PF: ["skipass"],
    PFCS: ["skipass"],
    PFP: ["skipass", "materiel"],
    PFPCS: ["skipass", "materiel"],
    PFTT: ["transport", "skipass"],
    PFTTF: ["transport", "skipass"],
    PFPTTF: ["transport", "skipass", "materiel"],
    PMA: ["passMultiActivities"],
};
